import React from 'react';
import _ from 'lodash';

import RadioGroup from 'components/RadioGroup/RadioGroup';
import { ResourceRelationLevel, OrgRelationAccess } from 'utils/types';

export const NoRelation = 'none';

export const ResourceRadios = [
  {
    id: ResourceRelationLevel.none,
    label: 'none'
  },
  {
    id: ResourceRelationLevel.manager,
    label: 'manager'
  },
  {
    id: ResourceRelationLevel.owner,
    label: 'owner'
  },
  {
    id: ResourceRelationLevel.member,
    label: 'member'
  }
];

export const GroupRelationMap = [
  {
    id: ResourceRelationLevel.manager,
    label: 'manager'
  },
  {
    id: ResourceRelationLevel.owner,
    label: 'owner'
  },
  {
    id: ResourceRelationLevel.member,
    label: 'member'
  }
];

export const OrgAccessLevelMap = [
  {
    id: OrgRelationAccess.manager,
    label: 'manager'
  },
  {
    id: OrgRelationAccess.owner,
    label: 'owner'
  },
  {
    id: OrgRelationAccess.viewer,
    label: 'viewer'
  }
];

const RelationRadios = ({ radios, id, relation, onRelationChanged }) => {
  const rowRadios = _.map(radios, (radio) => ({ ...radio, name: id, id: `${id}-${radio.id}` }));

  return (
    <RadioGroup
      radios={rowRadios}
      value={`${id}-${relation}`}
      onValueChanged={(value) => {
        onRelationChanged(_.last(_.split(value, '-')), relation);
      }}
    />
  );
};

export default RelationRadios;
